<template>
  <div v-if="isLoading">
    <Loader></Loader>
  </div>
  <div v-else>
    <b-row>
      <b-col>
        <button
          type="button"
          class="btn btn-sm btn-default"
          @click="toggleInvoiceShowModal(item)"
        >{{$t('buttons.downloadPDF')}}</button>
        <button
          v-if="!item.accepted"
          type="button"
          class="btn btn-sm btn-warning"
          @click="acceptInvoice(item)"
        >{{$t('buttons.acceptInvoice')}}</button>
        <button
          v-else
          type="button"
          class="btn btn-sm btn-warning"
          @click="showModalToSendInvoice"
        >{{$t('views.exsbinvoices.form.sendInvoice')}}</button>
        <router-link v-if="item.idAgreement" :to="{name: 'EXABAgreementShow', params: {id: item.idAgreement}}" type="button" class="btn btn-sm btn-default">{{ $t('views.excmdevice.show.clientSection.deviceAgreement.moveToAgreement') }}</router-link>
        <router-link :to="{name: 'EXSBInvoiceUpdate', params: {id: item['@id']}}" type="button" class="btn btn-sm btn-default">{{ $t('buttons.edit') }}</router-link>
        <button v-if="ableToCreateDocument" type="button" class="btn btn-sm btn-warning float-left" @click="toggleCreateFromInvoiceModal()">{{$t('buttons.generateDocument')}}</button>
        <div class="btn-group float-right">
          <router-link tag="button" v-if="item && ableToListInvoices && item.accepted === 1" :to="{ name: 'EXSBInvoiceList' }" class="mb-1 btn btn-sm btn-default">{{$t('buttons.backToList')}}</router-link>
          <router-link tag="button" v-else-if="item && ableToListInvoices && item.accepted === 0" :to="{ name: 'EXSBNotAcceptedInvoiceList' }" class="mb-1 btn btn-sm btn-default">{{$t('buttons.backToList')}}</router-link>
          <button type="button" class="mb-1 btn btn-sm btn-default" @click="$router.go(-1)">{{$t('buttons.goBack')}}</button>
        </div>
      </b-col>
    </b-row>
    <InvoiceShow :able-to-edit-invoice="ableToEditInvoice" :item="item"/>
    <b-modal size="lg" ref="modalToSendInvoice" hide-footer>
      <div slot="modal-header">
        <h6 class="modal-title m-0 float-left">
          {{$t('views.exsbinvoices.form.sendInvoice')}}
        </h6>
        <button type="button" aria-label="Close" class="close" @click="hideModalToSendInvoice()">
          ×
        </button>
      </div>
      <b-row>
        <b-col cols="12">
          <b-form-group>
            <label>{{$t('views.exsbinvoices.form.sentDate')}}:</label>
            <VueCtkDateTimePicker no-header
                                  :label="$t('views.exsbinvoices.form.sentDate')"
                                  v-model="sentDate"
                                  format="YYYY-MM-DD HH:mm"
                                  :onlyDate="false"
                                  :right="true"
                                  formatted="YYYY-MM-DD HH:mm"
            >
            </VueCtkDateTimePicker>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <label for="custom_email_content">{{ $t('views.excmnotificationmessage.form.mailTitle') }}:</label>
            <input
              id="issuePlace"
              v-model="invoiceSettings.invoiceMailTitle"
              :class="['form-control']"
              type="text"
              placeholder=""
            >
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <label for="custom_email_content">{{ $t('views.externalform.form.emailContent') }}:</label>
            <trumbowyg ref="editor" v-model="invoiceSettings.customEmail" :config="trumbowygConfig" class="form-control" name="htmlContent">
            </trumbowyg>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <button @click="sendInvoice(item)" class="btn btn-primary">{{ $t('views.exsbinvoices.form.sendSelectedInvoices') }}</button>
          <b-btn @click="hideModalToSendInvoice" variant="danger">{{ $t('buttons.close') }}</b-btn>
        </b-col>
      </b-row>
    </b-modal>
    <InvoicePositionEditModal></InvoicePositionEditModal>
    <InvoiceDataEditModal></InvoiceDataEditModal>
    <DocumentCreateFromInvoiceModal></DocumentCreateFromInvoiceModal>
    <InvoiceShowModal></InvoiceShowModal>
    <InvoiceAcceptModal></InvoiceAcceptModal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles.js'
import InvoicePositionEditModal from './components/InvoicePositionEditModal/InvoicePositionEditModal'
import InvoiceDataEditModal from './components/InvoiceDataEditModal/InvoiceDataEditModal'
import ShowInvoiceMixins from '@/components/Dashboard/Views/common/ShowInvoiceMixins'
import Loader from '@/components/Dashboard/Layout/Loader'
import DocumentCreateFromInvoiceModal from '@/components/Dashboard/Views/BusinessBundle/exsbdocument/modals/DocumentCreateFromInvoiceModal'
import getId from '@/utils/getIdFromLink'
import InvoiceShowModal from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/modals/InvoiceShowModal'
import InvoiceAcceptModal from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/modals/InvoiceAcceptModal'
import ApiService from '@/utils/ApiService'
import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import InvoiceShow from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/InvoiceShow'

export default {
  mixins: [ShowInvoiceMixins],
  components: {
    InvoiceShow,
    InvoiceShowModal,
    InvoicePositionEditModal,
    InvoiceDataEditModal,
    Loader,
    DocumentCreateFromInvoiceModal,
    InvoiceAcceptModal,
    Trumbowyg,
    VueCtkDateTimePicker
  },
  data () {
    return {
      sentDate: '',
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btnsDef: {
          // Create a new dropdown
          image: {
            dropdown: ['insertImage'], /*, 'base64' */
            ico: 'insertImage'
          },
          insertText: {
            fn: () => this.insertText(),
            ico: 'blockquote'
          }
        },
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['link'],
          ['image'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['insertText']
        ],
        lang: this.$i18n.locale
      },
      invoiceSettings: {
        issuePlace: '',
        comments: '',
        customEmail: '',
        invoiceMailTitle: ''
      }
    }
  },
  computed: {
    ableToCreateDocument () {
      return checkPermission('warehouses', 'EXSBDocumentCreate') && this.item && this.item.documents.length < 0
    },
    ableToEditInvoice () {
      if (!this.item) return false
      else {
        return checkPermission('finances', 'EXSBInvoiceUpdate') && this.item.accepted === 0
      }
    },
    ableToListInvoices () {
      return checkPermission('finances', 'EXSBInvoiceList')
    },
    ...mapGetters({
      deleteError: 'exsbinvoice/del/error',
      error: 'exsbinvoice/show/error',
      isLoading: 'exsbinvoice/show/isLoading',
      item: 'exsbinvoice/show/retrieved'
    })
  },

  beforeCreate () {
    checkPagePermission('finances', 'EXSBInvoiceShow')
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    acceptInvoice () {
      this.toggleInvoiceAcceptModal()
    },
    showModalToSendInvoice () {
      this.getInvoiceSettings()
      this.$refs['modalToSendInvoice'].show()
    },
    hideModalToSendInvoice () {
      this.$refs['modalToSendInvoice'].hide()
    },
    async sendInvoice (item) {
      let selections = [getId(item['@id'])]
      let params = {
        selections: selections,
        sentDate: this.sentDate,
        messageTitle: this.invoiceSettings.invoiceMailTitle,
        messageContent: this.invoiceSettings.customEmail
      }
      await new ApiService('e_x_s_b_invoices/invoicessend').post(params)
      this.$refs['modalToSendInvoice'].hide()
      this.retrieve(decodeURIComponent(this.$route.params.id))
    },
    toggleInvoiceShowModal (item) {
      this.fetchInvoiceAsPDF(getId(item['@id']))
      this.setInvoiceNumber(item.number)
      this.toggleModal()
    },
    async getInvoiceSettings () {
      let owner = await new ApiService('owners/1').getResults()
      if (!owner.invoiceSettings || owner.invoiceSettings.length === 0) {
        this.invoiceSettings = {
          issuePlace: '',
          comments: '',
          customEmail: '',
          invoiceMailTitle: ''
        }
      } else {
        this.invoiceSettings = owner.invoiceSettings
      }
    },
    ...mapMutations({
      toggleModal: 'exsbinvoice/showModal/toggleModal',
      setInvoiceNumber: 'exsbinvoice/showModal/setInvoiceNumber',
      toggleCreateFromInvoiceModal: 'exsbdocument/createModal/toggleCreateFromInvoiceModal',
      toggleInvoiceAcceptModal: 'exsbinvoice/acceptModal/toggleModal'
    }),
    ...mapActions({
      del: 'exsbinvoice/del/del',
      reset: 'exsbinvoice/show/reset',
      retrieve: 'exsbinvoice/show/retrieve',
      fetchInvoiceAsPDF: 'exsbinvoice/showModal/fetchInvoiceAsPDF'
    })
  }
}
</script>
